import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sklBadgeText', pure: true
})
export class BadgeTextPipe implements PipeTransform {
    public transform(input: string, pattern?: RegExp, cssClassName?: string): string {
        const badgeClassName = cssClassName ? `badge ${cssClassName}` : 'badge';
        let output = input;
        if (pattern) {
            input.match(pattern)?.forEach(val => {
                output = output.replace(val, `<span class="${badgeClassName}">${val}</span>`);
            });

            return output;
        }

        return `<span class="${badgeClassName}">${output}</span>`;
    }
}
